import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../base/firestore-model-base'
import type { CompanySurveyAnswerDoc } from './company_survey_answer_model'

/**
 * CompanySurveyAnswerHistory（事業所アンケート回答の変更履歴）
 *
 * - school / admin: 履歴の読み取り可
 * - anon: 追加（create）のみ可能（回答送信時に1件追加）
 *
 * パス: school_accounts/{uid}/projects/{projectId}/town_companies/{townCompanyId}/survey_answers/current/history/{historyId}
 */

export type CompanySurveyAnswerHistoryDoc = FirestoreBaseDoc & {
  /** 当時点の回答スナップショット */
  answer: CompanySurveyAnswerDoc
  /** 更新者種別 */
  updated_by_user_type: 'admin' | 'school' | 'anon'
  /** 更新者ID（anon の場合は未設定可） */
  updated_by_user_id?: string | null
  /** 更新者名（anon の場合は未設定可） */
  updated_by_name?: string | null
  /** 更新者ドキュメントパス（admin/school 用） */
  updated_by_user_document_path?: string | null
  /** 更新内容の補足 */
  update_info?: string | null
}

export type CompanySurveyAnswerHistoryEntity = AppBase & {
  answer: CompanySurveyAnswerDoc
  updated_by_user_type: 'admin' | 'school' | 'anon'
  updated_by_user_id?: string
  updated_by_name?: string
  updated_by_user_document_path?: string
  update_info?: string
}

export const companySurveyAnswerHistoryDocConverter =
  makeDocConverter<CompanySurveyAnswerHistoryDoc>()

export function toCompanySurveyAnswerHistoryEntity(
  id: string,
  doc: CompanySurveyAnswerHistoryDoc,
  path: string,
): CompanySurveyAnswerHistoryEntity {
  return {
    ...baseFromDoc(id, doc, path),
    answer: doc.answer,
    updated_by_user_type: doc.updated_by_user_type,
    updated_by_user_id: doc.updated_by_user_id ?? undefined,
    updated_by_name: doc.updated_by_name ?? undefined,
    updated_by_user_document_path: doc.updated_by_user_document_path ?? undefined,
    update_info: doc.update_info ?? undefined,
  }
}
